import React from 'react';
import { useItemsInView } from '../../utils/useItemsInView';
import InfiniteList from './items/InfiniteList';
import TrackRow from './items/TrackRow';
export default function DescriptiveRowDialogWidget(props) {
    const callbackRef = useItemsInView(props.onViewed);
    return (React.createElement(InfiniteList, { data: props.data, handleSelected: props.handleSelected, componentType: TrackRow, itemsViewedRef: callbackRef, scrollToIndex: -1, rowHeight: 46, isDynamicRowHeightEnabled: true, isResizableRowList: true }));
}
